import { render, staticRenderFns } from "./chat-session.vue?vue&type=template&id=253b5866&scoped=true&"
import script from "./chat-session.vue?vue&type=script&lang=js&"
export * from "./chat-session.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253b5866",
  null
  
)

export default component.exports